export type Configuration = {
  ignoreOutOfStock: boolean;
};

export const currentConfiguration: Configuration = {
  ignoreOutOfStock: false,
};
